import React, { useState, useEffect } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import PrintHeader from "../common/PrintHeader";
import Chart from "./_Chart";
import { formatPrintMoney, paymentField } from "../financePrintUtils";
import {
    ReceiptAmountIcon,
    ReceiptCalendarIcon,
    ReceiptDocIcon,
    ReceiptUserIcon,
} from "../teacher-salary-report/_ReceiptDetailIcons";

const RevenuePaymentReceipt = (props) => {

    const {type, account, subAccount, receipt_id, halfYear} = props.match.params;

    const [payment, setPayment] = useState({});
    const [budget, setBudget] = useState({});

    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'سند دریافت';

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        let query = `revenues/types/${type}/accounts/${account}/subAccounts/${subAccount}/revenues?halfYearId=${halfYear}`;
        let query2 = `revenues/types/${type}/accounts/${account}/subAccounts?halfYearId=${halfYear}`;

        await db.getAll(query).then(({ data }) => {
            if (data.data)
                for (let p of data.data)
                    if (p.id == receipt_id)  setPayment(p);
        });

        await db.getAll(query2).then(({ data }) => {
            if (data.data)
                for (let p of data.data)
                    if (p.id == subAccount)  setBudget(p);
        });
    };

    const receiptDate = paymentField(payment, "receipt_date", "payment_date", "date");
    const receivedBy = paymentField(
        payment,
        "received_by_staff",
        "received_by_staff_name",
        "received_by"
    );
    const refNo = paymentField(payment, "bank_ref_no", "reference");
    const paymentAmount = paymentField(payment, "amount");

    const detailRows = [
        { label: 'تاریخ', value: receiptDate, Icon: ReceiptCalendarIcon },
        { label: 'دریافت کننده', value: receivedBy, Icon: ReceiptUserIcon },
        { label: 'ريفرنس نمبر', value: refNo, Icon: ReceiptDocIcon },
        {
            label: 'مبلغ',
            value: paymentAmount !== '' ? formatPrintMoney(paymentAmount) : '',
            Icon: ReceiptAmountIcon,
            bold: true,
        },
    ];

    return (
        <main className="main-print-wrapper payment-receipt-print revenue-payment-receipt-print">
            <PrintHeader
                title={title}
                subtitle={payment?.half_year || ""}
                date={" "}
                printHeadTexts={printHeadTexts}
                landscape
            />

            <div style={{display: "grid", gap: "10px", marginBottom: "5px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>
                    <div className="report-summary-area white-background-with-border">
                        <Chart data={budget && budget}/>
                    </div>
                    <div className="white-background-with-border print-finance-profile-panel">
                        <div className="overall-summary">
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(budget?.balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row print-finance-profile-row--info-only">
                            <div className="print-finance-profile-meta">
                                <div className="wrapper">
                                    <h3>{budget?.expense_account || budget?.revenue_account}</h3>
                                    <p>{budget?.name}</p>
                                    <p>{budget?.budget_code}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="print-finance-details-row" style={{paddingTop: "20px", display: "grid", gridTemplateColumns: "60% auto", gap: "20px"}}>
                <div className="receipt-sub-card-container receipt-remark-wrap" style={{height: "100%"}}>
                    <div className="sub-card receipt-remark-card" style={{height: "100%", display: "grid", gridTemplateColumns: "1fr auto", alignItems: "center", columnGap: "12px"}}>
                        <p className="content content-rtl" style={{padding: "0 5px"}}>{payment?.remark ?? ''}</p>
                        <p className="label">{'توضيحات'}</p>
                    </div>
                </div>

                <div className="receipt-sub-card-container receipt-field-cards">
                    {detailRows.map(({ label, value, Icon, bold }) => (
                        <div key={label} className={`sub-card receipt-field-card${bold ? " bold" : ""}`}>
                            <span className="receipt-detail-icon" aria-hidden="true">
                                <Icon />
                            </span>
                            <p className="content">{value}</p>
                            <p className="label">{label}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء دریافت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default RevenuePaymentReceipt;
